import { useTranslation } from 'react-i18next';

export const useValidationUtils = () => {
  const { t } = useTranslation();

  const errorsTop = (value: string) => {
    if (Number(value) < 0) {
      return `${t('minimumPossibleValue')} 0`;
    }

    if (Number(value) > 500) {
      return `${t('maximumPossibleValue')} 500`;
    }

    return null;
  };

  return {
    errorsTop,
  };
}; 